import React, { useState } from "react";
import { Button, Segmented, message } from "antd";
import { NextButton, PreviousButton } from "@comps/components";
import IndexMachines from "@mods/masterManagement/system/components/machines/IndexMachine";
import IndexAdmsMachines from "@mods/masterManagement/system/components/admsMachines/IndexAdmsMachines";
import ReadinessSummary from "./ReadinessSummary";

// Step 4 — Attendance Machine Integration. Reuses the two existing System
// Master screens (same as the "Machines" / "ADMS Machines" tabs there):
//   • ADMS Enabled  -> IndexAdmsMachines (push/ADMS devices console)
//   • ADMS Disabled -> IndexMachines     (standard machines list)
// A category selector switches between them. Optional step (skippable).

const StepAttendanceMachines = (props) => {
  const { wizard, patch, onNext, onBack, readiness, readinessLoading, refreshReadiness, statuses, skipStep, clearSkip } = props;
  const [category, setCategory] = useState(wizard.machines?.category || "adms");

  const onCategory = (val) => {
    setCategory(val);
    clearSkip?.("machines");
    patch({ machines: { category: val } });
  };

  const continueStep = () => {
    clearSkip?.("machines");
    patch({ machines: { category } });
    refreshReadiness?.();
    onNext();
  };

  const skip = () => {
    skipStep?.("machines");
    message.info("Attendance devices skipped for now.");
    onNext();
  };

  return (
    <>
      <div className="onb-card-title">Attendance machine integration</div>
      <div className="onb-card-sub">
        Optional: connect biometric or attendance devices now, or skip and use manual/web attendance until devices are ready.
      </div>

      <ReadinessSummary
        status={statuses.machines}
        loading={readinessLoading}
        onRefresh={refreshReadiness}
        items={[
          { label: "Standard devices", value: readiness.machines.standardCount || 0 },
          { label: "ADMS devices", value: readiness.machines.admsCount || 0 },
          { label: "Selected mode", value: category === "adms" ? "ADMS" : "Standard" },
        ]}
      />

      <div className="onb-machine-cat">
        <span className="onb-machine-cat-label">Category</span>
        <Segmented
          value={category}
          onChange={onCategory}
          options={[
            { label: "ADMS Enabled", value: "adms" },
            { label: "ADMS Disabled", value: "standard" },
          ]}
        />
      </div>

      <div className="onb-embed">
        {category === "adms" ? (
          <IndexAdmsMachines modkey="machines" />
        ) : (
          <IndexMachines modkey="machines" />
        )}
      </div>

      <div className="onb-foot">
        <PreviousButton onClick={onBack} text="Back" />
        <span className="spacer" />
        <Button onClick={skip}>Skip for now</Button>
        <NextButton onClick={continueStep} text="Continue" />
      </div>
    </>
  );
};

export default StepAttendanceMachines;
